import axios from 'axios'
import { path } from 'ramda'

import { getUser } from './auth/auth'

export const uploadFile = async (file: File) => {
  const { token } = getUser();
  const formData = new FormData()
  formData.append('files', file)


  return axios // using rest since image upload doesn't work through graphql now. https://github.com/strapi/strapi/issues/2558
    .post(`${process.env.GATSBY_API_URL}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      }
    ).then(data => {
      return path(['data', 0, 'id'], data)
    }).catch(response => response)
}
